module.exports = __webpack_public_path__ + "static/dinesh-16c7b564c394c276ca9995215a886b0b.png";